import React from 'react';

export const FaultToolTip = (startTimeText, endTimeText, displayStatus, toolTipClass ) => {
    return (
        <div style={{ width: '200px' }}>
            <div className={toolTipClass}>
                <div style={{ float: 'left', width: '50px', textAlign: 'right', paddingRight: '1rem' }}>Start:</div>
                <div style={{ float: 'right' }}>{startTimeText.trim()}</div>
            </div>
            <div className={toolTipClass}>
                <div style={{ float: 'left', width: '50px', textAlign: 'right', paddingRight: '1rem' }}>End:</div>
                <div style={{ float: 'right' }}>{endTimeText.trim()}</div>
            </div>
            <div className={toolTipClass}>
                <div style={{ float: 'left', width: '50px', textAlign: 'right', paddingRight: '1rem' }}>Status:</div>
                <div style={{ float: 'right' }}>{displayStatus}</div>
            </div>
        </div>
    );
};
